"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.sign = exports.urlSafeEncode = exports.isSecureConfig = exports.isOffsetGravity = exports.isFocusPoint = exports.isRGBColor = void 0;
var crypto_1 = __importDefault(require("crypto"));
var isRGBColor = function (obj) {
    return typeof obj === 'object' && 'r' in obj && 'g' in obj && 'b' in obj;
};
exports.isRGBColor = isRGBColor;
var isFocusPoint = function (obj) {
    return typeof obj === 'object' && 'x' in obj && 'y' in obj;
};
exports.isFocusPoint = isFocusPoint;
var isOffsetGravity = function (obj) {
    return (typeof obj === 'object' &&
        typeof obj.xOffset === 'number' &&
        typeof obj.yOffset === 'number' &&
        typeof obj.type === 'string');
};
exports.isOffsetGravity = isOffsetGravity;
var isSecureConfig = function (config) {
    return 'key' in config && 'salt' in config;
};
exports.isSecureConfig = isSecureConfig;
var hexDecode = function (hex) { return Buffer.from(hex, 'hex'); };
var urlSafeEncode = function (data) {
    return Buffer.from(data, 'utf8')
        .toString('base64')
        .replace(/=/g, '')
        .replace(/\+/g, '-')
        .replace(/\//g, '_');
};
exports.urlSafeEncode = urlSafeEncode;
var sign = function (key, salt, target, size) {
    if (size === void 0) { size = 32; }
    var hmac = crypto_1["default"].createHmac('sha256', hexDecode(key));
    hmac.update(hexDecode(salt));
    hmac.update(target);
    return (0, exports.urlSafeEncode)(hmac.digest().slice(0, size));
};
exports.sign = sign;
